import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../ApiGenericResponse";

export class InsertSmartLockClosingCodeResData extends ApiGenericResponse {
    challengeCode: string;

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.ChallengeCode) this.challengeCode = obj.ChallengeCode;
    }
}
